const ACCESS_TOKEN_NAME = 'accessToken';
const REFRESH_TOKEN_NAME = 'refreshToken';
const AUTH_COOKIE_DOMAIN = (window as any).REACT_APP_AUTH_COOKIE_DOMAIN;

export const removeCookieByName = (name: string) => {
    document.cookie = name + '=' + '; domain=' + AUTH_COOKIE_DOMAIN + '; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};

export const removeAllAuthCookies = () => {
    removeCookieByName(ACCESS_TOKEN_NAME);
    removeCookieByName(REFRESH_TOKEN_NAME);
};
